import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';

export const selectTravelTime = createSelector(selectJsonQuery, jsonQuery => getRangeValue('foot_min')(jsonQuery)?.lte);
